import Button, { ButtonProps } from 'components/common/Button';
import * as React from 'react';
import { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

interface Props extends ButtonProps {
  url: string;
  openNewTab?: boolean;
}

const LinkButton = ({ url, openNewTab = false, children, ...rest }: Props): ReactElement => {
  const history = useHistory();
  const {
    location: { pathname, search },
  } = history;

  if (openNewTab) {
    return (
      <Button {...rest}>
        <NewTabAnchor href={url} target="_blank" rel="noopener noreferrer">
          {children}
        </NewTabAnchor>
      </Button>
    );
  }

  return (
    <Button
      onClick={() => {
        history.push(url, {
          previousPath: `${pathname}${search}`,
        });
      }}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default LinkButton;

const NewTabAnchor = styled.a`
  display: inline-block;
  text-decoration: none;
  color: inherit;
`;
